/** Possible resources in lonely */
export enum LonelyResource {
  Nanite = "Nanite",
}
